<template>
	<div class="vue-tag-test">
		<vue-tags-input
				v-model="tag"
				:tags="tags"
				:validation="validation"
				placeholder="Add Search Criteria"
				:autocomplete-items="autocompleteItemsFiltered"
				:autocomplete-min-length="autocompleteMinLength"
				:autocomplete-always-open="autocompleteAlwaysOpen"
				@tags-changed="tagsChanged"
				@before-adding-tag="beforeSavingTag"
				@focus="onVueTagsInputFocus"
				@blur="onVueTagsInputBlur"
		/>
		<slot></slot>
	</div>
</template>

<script>
import VueTagsInput from '@johmun/vue-tags-input';
import $ from "jquery";
import {EventBus} from '@/event-bus'

let Subtract = require('array-subtract')
let subtract = new Subtract((a, b) => {
	let re = /([^:]*):[^:]*/

	let replace = b.text.replace(re, '$1')

	return a.text === replace
})

export default {
	name: "SearchCriterion",
	components: {VueTagsInput},
	props: {
		autoComplete: Array,
		tags: Array,
		index: Number
	},
	data() {
		return {
			re: /^([^:]*):[^:]*$/,
			autocompleteMinLength: 0,
			tag: '',
			autocompleteItems: [
				{
					text: 'Sterling'
				},
				{
					text: 'Vincent'
				},
				{
					text: 'Rouse'
				},
				{
					text: 'Lynwood'
				},
				{
					text: 'Odell'
				},
				{
					text: 'Butler'
				},
			],
			autocompleteAlwaysOpen: false,
			validation: [
				{
					classes: 'has-colon',
					rule: /^([^:]*:[^:]*)$/,
					disableAdd: true
				}
			]
		}
	},
	methods: {
		onVueTagsInputFocus(event) {
			//Bubble focus event
			EventBus.$emit('search-criterion-input-focus')
		},
		onVueTagsInputBlur(event) {
			//Bubble blur event
			EventBus.$emit('search-criterion-input-blur', event)
		},
		beforeSavingTag: function (input) {
			let that = this
			let isAutoCompleteIndex = -1;
			let containsAutoCompleteIndex = -1
			let isAutoComplete = this.autoComplete.some(function (value, i) { //FIX! Use stopPropagation to prevent event from firing twice --svr
				let found = value.text.toLowerCase() === input.tag.text.toLowerCase() || value.text.toLowerCase() + ':' === input.tag.text.toLowerCase();
				if(found) isAutoCompleteIndex = i
				return found
			});
			let containsAutoComplete = this.autoComplete.some(function (value, i) {
				let found = input.tag.text.match(that.re);
				if(found) containsAutoCompleteIndex = i
				return found && found.length === 2 && value.text.toLowerCase() === found[1].toLowerCase()
			});
			let containsTags = this.tags.some(function (value, i) {
				let found = value.text.match(that.re);

				return found && found.length === 2 && input.tag.text.toLowerCase() === found[1].toLowerCase()
			});
			console.log('Contains tags: ' + containsTags)
			if (isAutoComplete && !input.tag.text.includes(':')) {
				// this.tag = input.tag.text + ':'
				this.tag = this.autoComplete[isAutoCompleteIndex].text + ':'
			} else if (isAutoComplete) {
				// this.tag = input.tag.text
				this.tag = this.autoComplete[isAutoCompleteIndex].text
			} else if (containsAutoComplete && !containsTags) {
				// input.addTag(input.tag)
				let re = /^([^:]*)(:[^:]*)$/
				input.tag.text = input.tag.text.replace(re, this.autoComplete[containsAutoCompleteIndex].text + '$2')
				input.addTag(input.tag)
			}
		},
		tagsChanged: function (newTags) {
			this.$emit('vue-tags-changed', {
				newTags: newTags,
				index: this.index
			})
		}
	},
	computed: {
		autocompleteItemsFiltered: function () {
			return this.autocompleteItemsMinusSelected.filter(value => {
				if (this.tag) {
					return value.text.toUpperCase().includes(this.tag.toUpperCase())
				} else {
					return true
				}
			})
		},
		autocompleteItemsMinusSelected: function () {
			return subtract.sub(this.autoComplete, this.tags)
		},
		searchCriteria: function () {
			return this.tags.map((value) => {
				let newValue = {}
				let values = value.text.split(':');
				newValue[values[0]] = values[1]
				return newValue
			})
		}
	}
}
</script>

<style>
.vue-tags-input {
    display: inline-block;
    width: 90%;
    max-width: none !important;
}

.vue-tags-delete {
    display: inline-block;
    padding-left: 1em;
}

.ti-input {
    border-radius: 0.25em;
    font-size: medium;
}

.ti-tag, .ti-selected-item {
    background-color: #007bff !important;
}

.ti-tag.ti-invalid, .ti-tag.ti-tag.ti-deletion-mark {
    background-color: #e54d42 !important;
}

</style>